const countryTable = {
	at: 'in Österreich',
	de: 'in Deutschland',
	ch: 'in der Schweiz'
};

export const getCountryByCode = (code?: string): string | undefined => {
	if (!code) {
		return undefined;
	}

	return countryTable[code?.toLowerCase()];
};
